var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { attrs: { slot: "demo" }, slot: "demo" },
      [
        _c("TabPanels", {
          attrs: {
            type: "singleCard",
            tabMarginLeft: 20,
            tabPanels: _vm.tabPanelsData,
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }